import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Featured() {
  const testimonials = [
    {
      name: "Sophia L",
      image: "https://r2.starryai.com/results/1000927543/7d77b274-fc40-4ada-8d90-33894c85838c.webp",
      review:
        "I've tried other preparation platforms before, but none come close to PrepNexis AI. The AI-powered learning approach truly personalized my study experience, making it feel like I had a dedicated tutor.",
      rating: 5,
    },
    {
      name: "James K",
      image: "https://img.freepik.com/premium-photo/shot-handsome-young-man-taking-selfies-while-trip-created-with-generative-ai_762026-48366.jpg?w=360",
      review:
        "PrepNexis AI's platform is intuitive and highly effective. I felt confident walking into my exams, knowing I had covered all essential topics. Highly recommended!",
      rating: 5,
    },
    {
      name: "Maria R",
      image: "https://cdn.prod.website-files.com/6600e1eab90de089c2d9c9cd/66d7a0b9e14ac0d375c4f59e_66b55330e10f5c421f163415_image_cecd131f_1721688108331_1024.jpeg",
      review:
        "PrepNexis AI was a game-changer for me. The practice tests and feedback gave me the confidence to excel in my PTE exams.",
      rating: 5,
    },
    {
      name: "Elena D",
      image: "https://img.freepik.com/premium-photo/realistic-selfie-pretty-young-woman_1278587-3880.jpg",
      review:
        "I loved the detailed feedback and progress tracking. It kept me motivated and on track to achieve my goals. Thank you, PrepNexis AI!",
      rating: 5,
    },
  ];

  // Slick Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h2 className="text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Read trusted reviews from our customers
        </h2>

        {/* Slick Slider */}
        <Slider {...sliderSettings} className="mt-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="px-4">
              <blockquote className="rounded-lg bg-gray-50 p-6 shadow-sm sm:p-8">
                <div className="flex items-center gap-4">
                  <img
                    alt={testimonial.name}
                    src={testimonial.image}
                    className="h-14 w-14 rounded-full object-cover"
                  />
                  <div>
                    <div className="flex justify-center gap-0.5 text-green-500">
                      {/* Star Rating */}
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <svg
                          key={i}
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <p className="mt-0.5 text-lg font-medium text-gray-900">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
                <p className="mt-4 text-gray-700">{testimonial.review}</p>
              </blockquote>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
